






















































































































































































































































































































































import {
  getLiveListApi,
  getLiveUrlApi,
  getAdminLiveUrlApi,
  endLiveApi,
  reviewLiveApi,
  studentWebUrlApi,
} from "@/api/live";
import {
  dateFormat,
  getCurrentWeek,
  getCurrentMonth,
} from "@/utils/timeFormat";
import { PageModule } from "@/store/module/page";
import { getSelectCourseList, getSelectClassList } from "@/api/globalSearch";
import { UserModule } from "@/store/module/user";
import { Vue, Component } from "vue-property-decorator";
import { getLessonStudentList } from "@/api/lesson";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
// import ElectronProtocolCheck from "@/utils/electronProtocolCheck";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  components: {
    commonStaffPullDown,
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  dialogTableVisible: boolean = false;
  linkData: any = [];
  linkLessonId: number = 0;
  searchInfo: any = {
    teacher_id: "",
    teacher_list: [],
    live_status: [],
  };
  refreshCountdown: number = 0;
  classList: any[] = [];
  courseList: any[] = [];
  tableData: any[] = [];
  currentSortField: string = "start_time";
  currentSortType: string = "ascending";
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  reviewDialogVisible: boolean = false;
  reviewDialogUrl: string = "";
  reviewDialogTitle: string = "";
  showConfirm: boolean = false; //显示自定义弹框;
  relationMessage: string = ""; // 弹框信息;
  className: string = ""; // 班级信息
  class_url: string = ""; // 路径信息
  // pickerOptions: any = {
  //   shortcuts: [
  //     {
  //       text: "今天",
  //       onClick(picker: any) {
  //         const today = new Date();
  //         picker.$emit("pick", [today, today]);
  //       },
  //     },
  //     {
  //       text: "最近7天",
  //       onClick(picker: any) {
  //         const today = new Date().getTime();
  //         const start = dateFormat(
  //           "YYYY-mm-dd",
  //           new Date(today - 3 * 24 * 60 * 60 * 1000)
  //         );
  //         const end = dateFormat(
  //           "YYYY-mm-dd",
  //           new Date(today + 3 * 24 * 60 * 60 * 1000)
  //         );
  //         picker.$emit("pick", [start, end]);
  //       },
  //     },
  //     {
  //       text: "最近30天",
  //       onClick(picker: any) {
  //         const today = new Date().getTime();
  //         const start = dateFormat(
  //           "YYYY-mm-dd",
  //           new Date(today - 15 * 24 * 60 * 60 * 1000)
  //         );
  //         const end = dateFormat(
  //           "YYYY-mm-dd",
  //           new Date(today + 15 * 24 * 60 * 60 * 1000)
  //         );
  //         picker.$emit("pick", [start, end]);
  //       },
  //     },
  //     {
  //       text: "本周",
  //       onClick(picker: any) {
  //         const arr = getCurrentWeek();
  //         picker.$emit("pick", arr);
  //       },
  //     },
  //     {
  //       text: "本月",
  //       onClick(picker: any) {
  //         const arr = getCurrentMonth();
  //         picker.$emit("pick", arr);
  //       },
  //     },
  //   ],
  // };
  created() {
    const arr = getCurrentWeek();
    this.searchInfo.lesson_date = [
      dateFormat("YYYY-mm-dd", arr[0]),
      dateFormat("YYYY-mm-dd", arr[1]),
    ];
    const cache = PageModule.pageInfo.liveManage;
    if (cache.page) {
      this.page = cache.page;
    }
    if (cache.sort_field && cache.sort_type) {
      this.currentSortField = cache.sort_field;
      this.currentSortType = cache.sort_type;
    }
    this.$nextTick(() => {
      const table: any = this.$refs.mainTable;
      table.sort(this.currentSortField, this.currentSortType);
    });
    this.handleSearchClass("");
    this.handleSearchCourse("");
  }
  get myTeacherId() {
    return UserModule.userInfo.staff_id;
  }
  getList(params: { page: number; page_size: number }, cb?: Function) {
    const option: any = {
      page: params.page,
      page_size: params.page_size,
      sort_type: this.currentSortType === "ascending" ? "asc" : "desc",
      sort_field: this.currentSortField,
    };
    if (this.searchInfo.class_id) {
      option.class_id = this.searchInfo.class_id;
    }
    if (this.searchInfo.course_id) {
      option.course_id = this.searchInfo.course_id;
    }
    if (this.searchInfo.teacher_id) {
      option.teacher_id = this.searchInfo.teacher_id;
    }
    if (this.searchInfo.lesson_date) {
      option.start_date = this.searchInfo.lesson_date[0];
      option.end_date = this.searchInfo.lesson_date[1];
    }
    if (this.searchInfo.live_status.length > 0) {
      option.live_status_arr = this.searchInfo.live_status;
    }
    getLiveListApi(option).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.map((item: any) => {
          item.weekZh = ["日", "一", "二", "三", "四", "五", "六"][
            item.week_day
          ];
        });
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.page = params.page;
        if (cb) {
          cb();
        }
      }
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  // 刷新逻辑
  clickRefresh() {
    if (this.refreshCountdown > 0) {
      return false;
    }
    this.getList(
      {
        page: this.page,
        page_size: this.pageSize,
      },
      () => {
        this.$message({
          type: "success",
          message: "数据已更新",
        });
        this.refreshCountdown = 5;
        const clock = setInterval(() => {
          if (this.refreshCountdown === 0) {
            clearInterval(clock);
          } else {
            this.refreshCountdown = this.refreshCountdown - 1;
          }
        }, 1000);
      }
    );
  }
  handleSortChange(data: any) {
    if (data.prop === "start_time") {
      this.currentSortType = data.order;
      this.currentSortField = "start_time";
      PageModule.SET_PAGE_INFO({
        name: "liveManage",
        key: "sort_field",
        value: "start_time",
      });
      PageModule.SET_PAGE_INFO({
        name: "liveManage",
        key: "sort_type",
        value: data.order,
      });
    }
    this.handleRefresh();
  }
  handleRefresh() {
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  handleSearchCourse(v: string) {
    getSelectCourseList({
      page: 1,
      page_size: 100,
      title: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.courseList = res.data.list;
      }
    });
  }
  handleSearchClass(v: any) {
    getSelectClassList({
      page: 1,
      page_size: 50,
      name: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.classList = res.data.list;
      }
    });
  }
  handleStartLive(lesson_id: number, row: any) {
    getLiveUrlApi({
      lesson_id: lesson_id,
    }).then((res: any) => {
      if (res.error_code === 21020001) {
        this.$alert(`授课时长已使用完毕，请充值后开课。`, `开课提示`, {
          confirmButtonText: "关闭",
          confirmButtonClass: "mwow-button-filled mini",
          type: "warning",
        });
      } else if (res.error_code === 0) {
        this.class_url = res.data.url;
        this.showConfirm = true;
        this.className = row.class.name;
      }
    });
  }
  handleViewLive(row: any) {
    this.$confirm(
      "巡课将产生额外的时间费用，确定要继续巡课？",
      `巡课 - ${row.class.name}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      }
    )
      .then(() => {
        getAdminLiveUrlApi({
          lesson_id: row.lesson_id,
        }).then((res: any) => {
          if (res.error_code === 21020001) {
            this.$alert(`授课时长已使用完毕，请充值后开课。`, `开课提示`, {
              confirmButtonText: "关闭",
              confirmButtonClass: "mwow-button-filled mini",
              type: "warning",
            });
          } else if (res.error_code === 0) {
            window.open(res.data.url, "_blank");
          }
        });
      })
      .catch(() => {});
  }
  handleEndLive(row: any) {
    this.$confirm(
      "强制下课后学员和教师将自动提示已下课，确定要继续强制下课？",
      `强制下课 - ${row.class.name}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      }
    )
      .then(() => {
        endLiveApi({
          lesson_id: row.lesson_id,
        }).then((res: any) => {
          this.$message({
            type: "success",
            message: "操作成功",
          });
        });
      })
      .catch(() => {});
  }
  handleReviewLive(row: any) {
    reviewLiveApi({
      lesson_id: row.lesson_id,
    }).then((res: any) => {
      // window.open(res.data.url, "_blank");
      this.reviewDialogVisible = true;
      this.reviewDialogUrl = res.data.url;
      this.reviewDialogTitle = `${row.class.name} - [回看] - [${row.date}]`;
    });
  }
  reviewDialogClose() {
    this.reviewDialogVisible = false;
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
    PageModule.SET_PAGE_INFO({
      name: "liveManage",
      key: "page",
      value: e,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  cloneStudentLink(data: any) {
    this.dialogTableVisible = true;
    this.linkLessonId = data.lesson_id;
    getLessonStudentList({
      page: 1,
      page_size: 100,
      lesson_id: data.lesson_id,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.linkData = res.data.list;
      }
    });
  }
  cloneLink(data: any) {
    studentWebUrlApi({
      lesson_id: this.linkLessonId,
      student_id: data.student_id,
    }).then((res: any) => {
      if (res.error_code === 0) {
        // 执行复制操作
        const urlText = `学员[${data.name}], 复制下面链接开始上课：\r\n ${
          process.env.VUE_APP_BASE_API + res.data.url
        }\r\n\r\n请在电脑端使用“Chrome浏览器”打开。\r\nChrome下载地址：${"https://www.google.cn/intl/zh-CN/chrome/"}`;
        const copyInput: any = document.createElement("textarea");
        document.body.appendChild(copyInput);
        copyInput.innerHTML = urlText;
        copyInput.setAttribute("code", 1);
        copyInput.select();
        document.execCommand("Copy");
        this.$message({
          type: "success",
          message: "复制成功",
        });
        copyInput.remove();
      }
    });
  }
  concel() {
    this.showConfirm = false;
  }
  setUp() {
    window.open(this.class_url, "_blank");
  }
  confirmBtn() {
    const win: any = window;
    const openUrl = this.class_url.replace("https://", "tcic://");
    win.protocolCheck(
      openUrl,
      // 成功打开的回调
      () => {
        return;
      },
      // 没有安装的回调
      () => {
        this.$message({
          type: "warning",
          message: "未安装应用，开始下载",
        });
        const agent = navigator.userAgent.toLowerCase();
        const isMac = /macintosh|mac os x/i.test(navigator.userAgent);
        const a = document.createElement("a");
        if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
          a.href =
            "https://res.qcloudclass.com/Desktop/1.6.8/TCIC_Demo_1.6.8_Setup.exe";
          a.click();
        }
        if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
          a.href =
            "https://res.qcloudclass.com/Desktop/1.6.8/TCIC_Demo_1.6.8_Setup.exe";
          a.click();
        }
        if (isMac) {
          a.href =
            "https://res.qcloudclass.com/Desktop/1.6.8/TCIC_Demo-1.6.8.dmg";
          a.click();
        }
      }
    );
  }
}
